import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Exclusive } from '../../../types/exclusive.interface';

@Component({
	selector: 'app-card-exclusive',
	templateUrl: './card-exclusive.component.html',
	styleUrls: ['./card-exclusive.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CardExclusiveComponent {
	@Input() exclusive: Exclusive;

	constructor() { }
}
